import React from "react";

export default function Myexperience() {
  return (
    <div>
      <div
        className="container-fluid mt-5"
        style={{
          backgroundColor: "black",
        }}
      >
        <div
          className="container-fluid myexp"
          style={{
            maxWidth: "1440px",
            height: "auto",
          }}
        >
          <div
            className="row myexp2"
            style={{
              maxWidth: "1280px",
            }}
          >
            <h1 className="text-white text-center sora myexh1 mt-5 mb-3">
              My <span className="span1">Experience</span>
            </h1>
            <div className="row myexp3 mb-3" style={{}}>
              <div
                className="col-12 d-flex justify-content-between align-items-center myexp4"
                style={{
                  height: "120px",
                  border: "1px solid white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{
                    justifyContent: "space-between",
                  }}
                >
                  <div className="imgsbox">

                  <img
                    className="pe-3 myexlogo"
                    src="/images/image 772.png"
                    alt=""
                    srcset=""
                    />
                  <img
                    className="pe-3 "
                    src="/images/google.png"
                    alt=""
                    srcset=""
                    />
                    </div>
                  <h1
                    className="text-white pe-3 sora myexh2"
                    style={{
                    
                    }}
                  >
                    Graphic Artist/Animator at Multinet-Sabaq
                  </h1>
                </div>
                <p className="text-white sora myexp1">2018</p>
              </div>
              <div
                className="col-12 d-flex justify-content-between align-items-center  myexp4"
                style={{
                  height: "120px",
                  border: "1px solid white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    className="pe-3 pb-3"
                    src="/images/youtube.png"
                    alt=""
                    srcset=""
                  />
                  <h1
                    className="text-white pe-3 sora myexh2"
                    style={{
                   
                    }}
                  >
                    Creative Head at Methologik
                  </h1>
                </div>
                <p className="text-white sora  myexp1">2019 2021</p>
              </div>
              <div
                className="col-12 d-flex justify-content-between align-items-center  myexp6"
                style={{
                  height: "120px",
                  border: "1px solid white",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{
                    justifyContent: "space-between",
                  }}
                >  <img
                className="pe-3 myexlogo"
                src="/images/image 773.png"
                alt=""
                srcset=""
              />
                
                  <h1
                    className="text-white pe-3 sora  myexh2"
                    style={{  }}
                  >
                    Creative Specialist
                  </h1>
                </div>
                <p className="text-white sora  myexp1">2022</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
